export const REPLY_POLICY = {
  FACEBOOK:
    'https://improve.com.ar/no-puede-responder-debido-a-restriccion-de-la-ventana-de-mensajes-de-24-horas/',//'https://developers.facebook.com/docs/messenger-platform/policy/policy-overview/',
  TWILIO_WHATSAPP:
    'https://improve.com.ar/no-puede-responder-debido-a-restriccion-de-la-ventana-de-mensajes-de-24-horas/'//'https://www.twilio.com/docs/whatsapp/tutorial/send-whatsapp-notification-messages-templates#sending-non-template-messages-within-a-24-hour-session',
};
